@if (pages?.length > 1) {
  <ul class="c-pagination">
    @if (!isFirstPage) {
      <li class="c-pagination__item">
        <a class="c-pagination__link" href="javascript:void(0)" [attr.aria-label]="'PAGINATION.previous' | translate" (click)="onSelectPrevious()">
          <i class="pi pi-chevron-left" aria-hidden="true"></i>
        </a>
      </li>
    }
    @for (page of visiblePages; track page) {
      <li class="c-pagination__item">
        <a class="c-pagination__link" href="javascript:void(0)" [class.is-active]="activePage === page" (click)="onSelectPage(page)">{{page}}</a>
      </li>
    }
    @if (!isLastPage) {
      <li class="c-pagination__item">
        <a class="c-pagination__link" href="javascript:void(0)" [attr.aria-label]="'PAGINATION.next' | translate" (click)="onSelectNext()">
          <i class="pi pi-chevron-right" aria-hidden="true"></i>
        </a>
      </li>
    }
  </ul>
}
